import { render } from "./carouselItems.vue?vue&type=template&id=18b60cdc"
import script from "./carouselItems.vue?vue&type=script&lang=js"
export * from "./carouselItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__